var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 8.00033C13.3333 8.36852 13.0348 8.66699 12.6666 8.66699L3.33325 8.66699C2.96506 8.66699 2.66658 8.36851 2.66658 8.00032C2.66658 7.63213 2.96506 7.33366 3.33325 7.33366L12.6666 7.33366C13.0348 7.33366 13.3333 7.63214 13.3333 8.00033Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47149 13.1377C8.21114 13.3981 7.78903 13.3981 7.52868 13.1377L2.86201 8.47108C2.60166 8.21073 2.60166 7.78862 2.86201 7.52827L7.52868 2.8616C7.78903 2.60125 8.21114 2.60125 8.47149 2.8616C8.73184 3.12195 8.73184 3.54406 8.47149 3.80441L4.27622 7.99967L8.47149 12.1949C8.73184 12.4553 8.73184 12.8774 8.47149 13.1377Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrow-left-white.208203c407eff8a554b272eacf165926.svg";
export { ForwardRef as ReactComponent };